import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {
  fixedToWithoutRound,
  getSideColor,
  getTokenDecimals,
  i18nizeDate,
  numberWithCommas
} from '../../../../helpers/Utils';
import moment from 'moment';
import ReactTable from 'react-table';
import {Link} from 'react-router-dom';
import Api from '../../../../services/Api';
import {store} from '../../../../AppRenderer';
import {capitalize, keyBy, values, mapValues, omit, reduce, find} from 'lodash';
import {baseTokenSymbol, fetchIntervalTime, reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ModalManager from '../../../../components/modal/ModalManager';
import TradesOutputForm from '../../../../containers/TradesOutputForm';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
    };
    this.renderPairFilter = this.renderPairFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
    this.pairs = keyBy(store.getState().general.pairs, 'name');
    if (props.match.params.group) {
      this.financialGroup = find(store.getState().app.financialGroups, obj => obj.name === props.match.params.group);
    }
  }

  async componentDidMount() {
    this.interval = setInterval(async () => {
        await this.fetchTradeHistory(this.table.state);
      }, fetchIntervalTime * 4
    );
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.group !== this.props.match.params.group) {
      if (nextProps.match.params.group) {
        this.financialGroup = find(
          store.getState().app.financialGroups,
          obj => obj.name === nextProps.match.params.group
        );
        this.fetchData(this.table.state);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchTradeHistory = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/trades',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(this.financialGroup ? {financialGroupId: this.financialGroup.id} : null),
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'timestamp') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        history: data.trades,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchTradeHistory(state);
    this.setState({loading: false});
  };

  getColumns = t => [
    {
      Header: t('Pair'),
      accessor: 'pair',
      filterable: true,
      Filter: this.renderPairFilter,
      Cell: props => <span>{this.pairs[props.value] ? this.pairs[props.value].localeName : props.value}</span>,
    },
    {
      Header: t('Side'),
      accessor: 'maker_side',
      width: 90,
      Cell: props => <span className={getSideColor(props.value)}>{t(capitalize(props.value))}</span>,
    },
    {
      Header: t('Price'),
      accessor: 'price',
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>
    },
    {
      Header: t('Amount'),
      accessor: 'amount',
      width: 100,
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
    },
    {
      Header: `${t('Value')} (${t(baseTokenSymbol)})`,
      accessor: 'cost_in_base',
      Cell: props => <span>{fixedToWithoutRound(props.value, getTokenDecimals(baseTokenSymbol))}</span>,
    },
    {
      Header: t('Buy Fee'),
      accessor: 'base_fee',
      width: 110,
      Cell: props => <span>{fixedToWithoutRound(props.value, getTokenDecimals(props.original.pair.split('/')[0]))}</span>,
    },
    {
      Header: t('Sell Fee'),
      accessor: 'quote_fee',
      width: 110,
      Cell: props => <span>{fixedToWithoutRound(props.value, getTokenDecimals(props.original.pair.split('/')[1]))}</span>,
    },
    {
      Header: t('Buyer'),
      accessor: 'buyer',
      Cell: props => {
        const {buyer, buyerFirstName, buyerLastName} = props.original;
        if (buyer) {
          return (
            <Link to={{pathname: '/dashboard/users/' + buyer}}>
              <div className='d-flex flex-row align-items-center text-success'>
                <i className='simple-icon-user'/>
                <span className='mx-1'>
                  {`${buyerFirstName} ${buyerLastName}`}
                </span>
              </div>
            </Link>
          );
        }
        return (
          <div className='d-flex flex-row align-items-center text-success'>
            <i className='simple-icon-user'/>
            <span className='mx-1'>
              {t('External User')}
            </span>
          </div>
        );
      },
    },
    {
      Header: t('Seller'),
      accessor: 'seller',
      Cell: props => {
        const {seller, sellerFirstName, sellerLastName} = props.original;
        if (seller) {
          return (
            <Link to={{pathname: '/dashboard/users/' + seller}}>
              <div className='d-flex flex-row align-items-center text-danger'>
                <i className='simple-icon-user'/>
                <span className='mx-1'>
                  {`${sellerFirstName} ${sellerLastName}`}
                </span>
              </div>
            </Link>
          );
        }
        return (
          <div className='d-flex flex-row align-items-center text-danger'>
            <i className='simple-icon-user'/>
            <span className='mx-1'>
              {t('External User')}
            </span>
          </div>
        );
      },
    },
    {
      Header: t('Date'),
      accessor: 'timestamp',
      minWidth: 120,
      filterable: true,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      Filter: this.renderDateFilter,
    },
  ];

  renderPairFilter({filter, onChange}) {
    const {t} = this.props;
    const options = values(this.pairs).map(pair => ({
      value: pair.name, label: pair.localeName,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  openOutputModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Trades Excel Output'),
      body: <TradesOutputForm financialGroupId={this.financialGroup ? this.financialGroup.id : undefined}/>,
    });
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  getTotalValue = () => {
    const {history} = this.state;
    return fixedToWithoutRound(
      reduce(history, function(sum, trade) {
        return sum + Number(trade.cost_in_base);
      }, 0),
      getTokenDecimals(baseTokenSymbol)
    );
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            {/*{!!this.financialGroup && <Badge className="text-one font-weight-normal" color="info" pill>{this.financialGroup.name}</Badge>}*/}
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row align-items-center justify-content-between text-one">
                  <div>
                    <span>{`${t('Total value of the following trades')}:`}</span>
                    <span className="text-info mx-2">{`${this.getTotalValue()} ${t(baseTokenSymbol)}`}</span>
                  </div>
                  <Button
                    outline
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.openOutputModal}>
                    <i className="icon-File-Excel text-large"/>
                    <span className="mx-1">{t('Excel output')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.history}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
